import React from "react";

import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";

import { Pill } from "src/base-components/Pill";
import { Tooltip } from "src/design-system/Tooltip";
import { ModelOptionBadgeConfig } from "src/genai/ModelSelector/types";

type ModelOptionBadgeProps = {
  badgeConfig: ModelOptionBadgeConfig;
};

export const ModelOptionBadge: React.FC<ModelOptionBadgeProps> = ({
  badgeConfig,
}) => {
  return (
    <Tooltip body={badgeConfig.tooltip} placement="right" asChild>
      <Pill size="sm" variant={badgeConfig.pillVariant}>
        <Pill.Text>{badgeConfig.label}</Pill.Text>
        <Pill.Icon icon={faInfoCircle} />
      </Pill>
    </Tooltip>
  );
};

/**
 * Badge config for Taktile-hosted (Bedrock) models.
 */
export const TAKTILE_HOSTED_BADGE_CONFIG: ModelOptionBadgeConfig = {
  label: "Taktile-hosted",
  tooltip:
    "This model is hosted by Taktile via AWS Bedrock for additional privacy. This might come with lower usage limits.",
  pillVariant: "gray",
};

/**
 * Badge config for models using BYOK (Bring Your Own Key) credentials.
 */
export const BYOK_BADGE_CONFIG: ModelOptionBadgeConfig = {
  label: "Custom key",
  tooltip:
    "This model will use your own API key configured in Settings > AI credentials.",
  pillVariant: "indigo-light",
};

/**
 * Badge config for deprecated models.
 */
export const DEPRECATED_BADGE_CONFIG: ModelOptionBadgeConfig = {
  label: "Deprecated",
  tooltip:
    "This model version is deprecated and will be removed soon. Please use Claude 4.5 for the most up to date model capabilities.",
  pillVariant: "orange",
};
